import { UniqueUserId, UtmFields, XyPixel } from '@xylabs/pixel'

export const createCustomJson = (): Record<string, string> => {
  const utmFields = new UtmFields()
  const utmFieldData = (utmFields.fields ?? []).slice(-1)[0]
  return createCustomFields(utmFieldData)
}

export const createCustomFields = (utmFieldData: Record<string, string>): Record<string, string> => {
  //this is required to get the tune fields
  const fields = customQueryFields()
  let exids: XyPixel['exids'] = {}
  try {
    exids = XyPixel.instance.exids || {}
  } catch {
    // Will error if XyPixel.init() was not executed
  }
  return {
    ...fields,
    context: 'checkout',
    emailHash: localStorage.getItem('xy_email_hash') ?? '',
    fbc: exids.fbc as string,
    fbp: exids.fbp as string,
    testData: localStorage.getItem('testData') ?? '',
    utm_adid: utmFieldData?.adid ?? fields.adid,
    utm_adsetid: utmFieldData?.utm_adsetid ?? fields.utm_adsetid,
    utm_campaign: utmFieldData?.campaign ?? fields.utm_campaign,
    utm_campaignid: utmFieldData?.campaignid ?? fields.utm_campaignid,
    utm_content: utmFieldData?.content ?? fields.utm_content,
    utm_medium: utmFieldData?.medium ?? fields.utm_medium,
    utm_source: utmFieldData?.source ?? fields.utm_source,
  }
}
const customQueryFields = () => {
  const result: Record<string, string> = {}
  for (const field of customQueryFieldsIds) {
    const value = sessionStorage.getItem(`xy_${field}`)
    if (value) {
      result[field] = encodeURIComponent(value)
    }
  }
  if (window.location.hostname.endsWith('gocoinapp.com')) {
    result.shipStationStoreId = '214167'
  }
  const uniqueId = new UniqueUserId()
  result.coin_uid = uniqueId.id
  return result
}
const customQueryFieldsIds = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_campaignid',
  'utm_adsetid',
  'utm_adid',
  'utm_content',
  'utm_term',
  'advertiser_id',
  'affiliate_id',
  'aff_id',
  'aff_sub',
  'aff_sub2',
  'aff_sub3',
  'aff_sub4',
  'aff_sub5',
  'aff_click_id',
  'camp_id',
  'contract_id',
  'country_name',
  'ddcref',
  'device_type',
  'gclid',
  'gclsrc',
  'lpid',
  'offer_id',
  'oid',
  'req_id',
  'sub_id',
  'tune_transaction_id',
  'fbc',
  'fbp',
]